// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

export const TEMPLATE_TYPE_SYSTEM = 'http://polarissleep.com/notification-template';
